import "./index.css"
import logo_hogcloud1 from "../../assets/images/hogcloud-logo1.svg";
import logo_hogcloud_forward from "../../assets/images/hogcloud_logo_forward.png";
import splash_image from '../../assets/images/hogcloud_splash_hero.webp';
import React, { useState } from 'react';
const product_default_snapcharm = '/images/snapcharms/standard_model_snowman1.webp';




const Home = () => {

    return <>

            <div className="cards-container-home">
            <div className="hero-image-wrap">
                <img src={splash_image} alt="Hogcloud hero" className="splash-image" onClick={() => {
                    window.location.href = "/shop"
                }} />
            </div>
                <div className="card" onClick={() => {
                    window.location.href = "/shop";
                }}>
                    <h2 className="card-header">Products</h2>
                    <div className="card-content">
                        <p>Checkout out our store for unique, handcrafted products.</p>
                    </div>
            
                </div>
                <div className="card hidden" onClick={() => {
                    window.location.href = "/services";
                }}>
                    <h2 className="card-header">Services</h2>
                    <div className="card-content">
                        <p>Professional services tailored to meet your business needs and objectives.</p>
                    </div>
                </div>
                <div className="card hidden" onClick={() => {
                    window.open("https://learning.hogcloud.net", "_blank");
                }}>
                    <h2 className="card-header">Learning</h2>
                    <div className="card-content">
                        <p>Educational resources, tutoring, and training programs to help you grow and succeed.</p>
                    </div>
                </div>
            </div>
            

    
    
    </>;
  
    };


export default Home;
